<template>
    <wizard-layout :id="this.step">
        <template>
            <wizard-box-left>

                <wizard-step :step="this.step" :header_step="this.header_step"></wizard-step>

                <wizard-header :title="this.title"></wizard-header>

                <div class="row d-flex">

                    <div class="col-12 mb-3">
                        <div class="row">
                            <div class="col-lg-2 col-12">
                                <label>Indirizzo*</label>
                            </div>
                            <div class="col-lg-10 col-12">
                                <vue-google-autocomplete
                                    class="form-control"
                                    :class="{'is-invalid': form.errors.name}"
                                    @place_changed="getAddressData"
                                    placeholder="Via Europa 30, Bologna"
                                ></vue-google-autocomplete>
                            </div>
                        </div>
                    </div>
                </div>

                <wizard-footer :step="this.step" :display_next_button="display_next_button" :step_0_address="this.address"></wizard-footer>

            </wizard-box-left>
            <wizard-box-right :id="this.step">
                <wizard-progress :progress="this.progress" :progress_title="this.progress_title" :progress_description="this.progress_description"></wizard-progress>
            </wizard-box-right>
        </template>
    </wizard-layout>
</template>

<script>
import WizardLayout from "@/Pages/Wizard/Layouts/WizardLayout";
import WizardBoxRight from "@/Pages/Wizard/Layouts/WizardBoxRight";
import WizardBoxLeft from "@/Pages/Wizard/Layouts/WizardBoxLeft";
import WizardStep from "@/Pages/Wizard/Elements/WizardStep";
import WizardHeader from "@/Pages/Wizard/Elements/WizardHeader";
import WizardProgress from "@/Pages/Wizard/Elements/WizardProgress";
import WizardFooter from "@/Pages/Wizard/Elements/WizardFooter";
import Input from "@/Jetstream/Input";
import * as VueGoogleMaps from 'vue2-google-maps'

export default {
    props: ['data'],

    components: {
        Input, WizardBoxLeft, WizardLayout, WizardBoxRight, WizardStep, WizardHeader, WizardProgress, WizardFooter,
        'vue-google-autocomplete': VueGoogleMaps.Autocomplete,
    },

    data() {
        return {
            step: 0,
            progress: 1,
            progress_title: "Vuoi vendere il tuo immobile?",
            progress_description: "Compila la richiesta e riceverai un’offerta istantanea.",
            address: '',
            header_step: 1,
            title: 'Dove si trova il tuo immobile?',
            form: this.$inertia.form({
                name: null,
                active: false,
            }),
        }
    },

    computed: {
        display_next_button() {
            return this.fieldsAreEmpty()
        }
    },

    methods: {
        getAddressData(payload) {
            let address = this.getAddressComponent(payload, 'route')

            this.address = payload.formatted_address
            this.form.name = address.long_name
        },

        getAddressComponent(payload, type) {
            let {address_components} = payload

            return address_components.filter(i => i.types.includes(type))[0]
        },

        startWizard() {
            this.$inertia.visit('/wizard/customer/1?address=' + this.address)
        },

        fieldsAreEmpty() {
            return this.address !== ''
        }
    },

    beforeMount() {
        localStorage.removeItem('current_property_id')
        localStorage.removeItem('current_property')
    }
}

</script>
